import { render } from "./MIcon.vue?vue&type=template&id=836dc6fc"
import script from "./MIcon.vue?vue&type=script&lang=js"
export * from "./MIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__